module.exports = __webpack_public_path__ + "static/media/estilosos_masculino_ate_200.39928996.jpg";